export default __webpack_public_path__ + "static/media/MS-Gothic.d72c7de8.ttf";